'use strict';

var ChartPriceRecommendationServicesLegendController = function ChartPriceRecommendationServicesLegendController($scope, $rootScope, svgPatternService) {
  $scope.fillSvgPattern = svgPatternService.getPatternUrl('user-exclusion');
};
ChartPriceRecommendationServicesLegendController.$inject = ['$scope', '$rootScope', 'SvgPatternService'];
module.exports = ChartPriceRecommendationServicesLegendController;